export const endpoints = {
  login: '/login',
  resetPassword: '/resetPassword',
  changePassword: '/changePassword',
  validatePasswordToken: '/validatePasswordToken',
}
